import { CartLinesUpdateEvent } from '@shopify/events';

// Sepet çekmecesi: "3'lü pakete geç" ve "+ Ekle" butonları (snippets/essental-sepet-alt.liquid).
// Sepeti güncelledikten sonra çekmeceyi, ürün kutusundaki sepete ekleme ile aynı olayla yeniletir.
const kok = () => window.Shopify?.routes?.root || '/';
const bolumler = () => [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);

async function guncelle(btn, istek) {
  const hata = btn.closest('.es-sepet-ek')?.querySelector('[data-es-sepet-hata]');
  if (hata) hata.hidden = true;
  btn.disabled = true;
  const ertelenen = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({ action: btn.closest('cart-drawer-component') ? 'update' : 'add', context: btn.closest('cart-drawer-component') ? 'cart' : 'product', lines: [], promise: ertelenen.promise }));
  try {
    const yanit = await istek(bolumler().join(','));
    const sepet = await fetch(`${kok()}cart.js`).then((r) => r.json());
    const detail = { items: sepet.items, source: 'essental-sepet', itemCount: sepet.item_count, sections: yanit.sections, didError: Boolean(yanit.status) };
    ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail });
    if (yanit.status && hata) { hata.textContent = yanit.description || 'Sepet güncellenemedi, tekrar dene.'; hata.hidden = false; }
  } catch (e) {
    ertelenen.reject(e);
    if (hata) { hata.textContent = 'Bağlantı sorunu oldu, tekrar dene.'; hata.hidden = false; }
  } finally {
    btn.disabled = false;
  }
}

const post = (yol, govde) => fetch(`${kok()}${yol}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(govde),
}).then((r) => r.json());

document.addEventListener('click', (e) => {
  const t = e.target instanceof Element ? e.target : null;
  const ekle = t?.closest('[data-es-ekle]');
  if (ekle) {
    e.preventDefault();
    guncelle(ekle, (sections) => post('cart/add.js', { items: [{ id: Number(ekle.dataset.varyant), quantity: 1 }], sections }));
    return;
  }
  const yuksel = t?.closest('[data-es-yukselt]');
  if (yuksel) {
    e.preventDefault();
    guncelle(yuksel, async (sections) => {
      await post('cart/change.js', { id: yuksel.dataset.satir, quantity: 0 });
      return post('cart/add.js', { items: [{ id: Number(yuksel.dataset.varyant), quantity: 1, properties: { _paket: '3 Şişe · 3 al 2 öde', Hediye: 'Lenf Masajı Rehberi' } }], sections });
    });
  }
});
